import { render, staticRenderFns } from "./editModal.vue?vue&type=template&id=2836fc19&"
import script from "./editModal.vue?vue&type=script&lang=js&"
export * from "./editModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports